import {
  Float,
  Box,
  Environment,
  RoundedBox,
  OrbitControls
} from "@react-three/drei";

import {
  editable as e,
  SheetProvider,
  useCurrentSheet,
  PerspectiveCamera
} from "@theatre/r3f";

export default function Cubicles() {
  return (
    <Float
      speed={5.5} // Animation speed, defaults to 1
      rotationIntensity={3} // XYZ rotation intensity, defaults to 1
      floatIntensity={1} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
      floatingRange={[-0.15, 0.15]} // Range of y-axis values the object will float within, defaults to [-0.1,0.1]
    >
      <group>
        <e.mesh theatreKey="bottom">
          <RoundedBox
            name="bottom"
            position={[0, -0.06, 0]}
            args={[1, 0.1, 1]}
            radius={0.02}
            smoothness={8}
            bevelSegments={4}
            creaseAngle={0.4}
          >
            <meshStandardMaterial
              color="#040179"
              metalness={0.95}
              roughness={0.4}
            />
          </RoundedBox>
        </e.mesh>

        <e.mesh theatreKey="right">
          <RoundedBox
            name="right"
            rotation={[1.57, 0, 0]}
            args={[1, 0.1, 1]}
            radius={0.02}
            smoothness={8}
            bevelSegments={4}
            creaseAngle={0.4}
          >
            <meshStandardMaterial
              color="#040179"
              metalness={0.95}
              roughness={0.36}
            />
          </RoundedBox>
        </e.mesh>

        <e.mesh theatreKey="top">
          <RoundedBox
            name="top"
            args={[1, 0.1, 1]}
            radius={0.02}
            smoothness={8}
            bevelSegments={4}
            creaseAngle={0.4}
          >
            <meshStandardMaterial
              color="#040179"
              metalness={0.95}
              roughness={0.36}
            />
          </RoundedBox>
        </e.mesh>

        <e.mesh theatreKey="left">
          <RoundedBox
            name="left"
            args={[1, 0.1, 1]}
            radius={0.02}
            smoothness={8}
            bevelSegments={4}
            creaseAngle={0.4}
          >
            <meshStandardMaterial
              color="#040179"
              metalness={0.95}
              roughness={0.36}
            />
          </RoundedBox>
        </e.mesh>

        <RoundedBox
          position={[0.548, 0.475, 0]}
          rotation={[1.57, 0, 1.57]}
          args={[1, 0.1, 1]}
          radius={0.02}
          smoothness={8}
          bevelSegments={4}
          creaseAngle={0.4}
        >
          <meshStandardMaterial
            color="#040179"
            metalness={0.95}
            roughness={0.36}
          />
        </RoundedBox>

        <RoundedBox
          position={[-0.548, 0.473, 0]}
          rotation={[1.57, 0, 1.57]}
          args={[1, 0.1, 1]}
          radius={0.02}
          smoothness={8}
          bevelSegments={4}
          creaseAngle={0.4}
        >
          <meshStandardMaterial
            color="#040179"
            metalness={0.95}
            roughness={0.36}
          />
        </RoundedBox>
      </group>
    </Float>
  );
}
